module.exports = __webpack_public_path__ + "static/media/Inter-SemiBoldItalic.6cd13dbd.woff";